import { SparklesIcon, ChartBarIcon, ArrowTrendingUpIcon, UsersIcon } from '@heroicons/react/24/outline';

const SAMPLE_QUESTIONS = [
  {
    category: 'Quick Insights',
    icon: SparklesIcon,
    questions: [
      "What are my top 10 customers by revenue?",
      "Show me total sales for this month",
      "What's my best performing product?"
    ]
  },
  {
    category: 'Trends',
    icon: ArrowTrendingUpIcon,
    questions: [
      "Show me sales trends over the last 6 months",
      "Compare revenue this quarter vs last quarter",
      "How is my revenue growing month over month?"
    ]
  },
  {
    category: 'Analysis',
    icon: ChartBarIcon,
    questions: [
      "Break down sales by region",
      "Which products have the highest profit margin?",
      "Show me customer acquisition by channel"
    ]
  },
  {
    category: 'Performance',
    icon: UsersIcon,
    questions: [
      "Who are my most active users?",
      "What's my customer retention rate?",
      "Show me churn rate by customer segment"
    ]
  }
];

export default function SampleQuestions({ onQuestionClick }) {
  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="text-center mb-8">
        <h2 className="text-2xl font-bold text-surface-900 dark:text-white mb-2">
          Ask a question about your data
        </h2>
        <p className="text-surface-600 dark:text-surface-400">
          Try these sample questions or type your own in natural language
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {SAMPLE_QUESTIONS.map((category) => (
          <div
            key={category.category}
            className="bg-white dark:bg-surface-800 rounded-xl border border-surface-200 dark:border-surface-700 p-5"
          >
            <div className="flex items-center gap-2 mb-4">
              <category.icon className="w-5 h-5 text-primary-500" />
              <h3 className="font-semibold text-surface-900 dark:text-white">
                {category.category}
              </h3>
            </div>
            <div className="space-y-2">
              {category.questions.map((question, idx) => (
                <button
                  key={idx}
                  onClick={() => onQuestionClick(question)}
                  className="w-full text-left px-4 py-3 rounded-lg bg-surface-50 dark:bg-surface-900 hover:bg-primary-50 dark:hover:bg-primary-900/20 hover:border-primary-200 dark:hover:border-primary-800 border border-surface-200 dark:border-surface-700 transition-all text-sm text-surface-700 dark:text-surface-300 hover:text-primary-700 dark:hover:text-primary-400"
                >
                  {question}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>

      <div className="bg-gradient-to-r from-blue-50 to-purple-50 dark:from-blue-900/20 dark:to-purple-900/20 rounded-xl p-6 border border-blue-200 dark:border-blue-800">
        <div className="flex items-start gap-3">
          <SparklesIcon className="w-6 h-6 text-blue-600 dark:text-blue-400 flex-shrink-0 mt-0.5" />
          <div>
            <h4 className="font-semibold text-surface-900 dark:text-white mb-2">
              Pro Tips for Better Results
            </h4>
            <ul className="space-y-2 text-sm text-surface-700 dark:text-surface-300">
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Be specific about time ranges (e.g., "last 30 days", "Q3 2023")</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Mention the metrics you want to see (revenue, count, average, etc.)</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Use dimensions from your data (region, product, category, etc.)</span>
              </li>
              <li className="flex items-start">
                <span className="text-blue-500 mr-2">•</span>
                <span>Ask follow-up questions to refine your results</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
